import { Component, Input, OnInit } from '@angular/core';
import { InjuryViewModel } from 'src/app/shared/models/injurymodel';
import { DatePipe } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-player-injury',
    templateUrl: './player-injury.component.html',
    styleUrls: ['./player-injury.component.css'],
    imports: [MatButton, RouterLink, DatePipe]
})
export class PlayerInjuryComponent implements OnInit {

  @Input() Injury: InjuryViewModel;
  bordercolor: string;

  constructor() { }

  ngOnInit() {
    if(this.Injury.IsActive)
      this.bordercolor = "injury_active_div";
    else
      this.bordercolor = "injury_div";
  }

}
